import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class OutpostSea4PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.OUTPOST_SEA4;
}

export default OutpostSea4PoiTileEntity;
